import Swal from 'sweetalert2';
import truckMarker from '@/assets/grua-map-icon-marker.png';

const STYLE_ID = 'tow-truck-loading-style';
const POPUP_CLASS = 'tow-truck-loading-popup';

function injectStyles() {
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    .${POPUP_CLASS} {
      border-radius: 18px !important;
      padding: 1.4rem 1.2rem 1.25rem !important;
    }
    .${POPUP_CLASS} .swal2-title {
      margin: 0 auto 0.55rem auto !important;
      text-align: center !important;
      width: 100%;
    }
    .${POPUP_CLASS} .swal2-html-container {
      margin: 0 auto !important;
      display: flex;
      justify-content: center;
      width: 100%;
    }
    .tow-truck-loader {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.55rem;
      min-width: 260px;
      color: #334155;
      margin: 0 auto;
    }
    .tow-truck-scene {
      position: relative;
      width: 230px;
      height: 92px;
      overflow: hidden;
    }
    .tow-truck-road {
      position: absolute;
      bottom: 13px;
      width: 100%;
      height: 5px;
      border-radius: 999px;
      background: repeating-linear-gradient(
        90deg,
        #cbd5e1 0px,
        #cbd5e1 18px,
        #94a3b8 18px,
        #94a3b8 30px
      );
      background-size: 140% 100%;
      animation: roadShift 1.1s linear infinite;
    }
    .tow-truck {
      position: absolute;
      left: 62px;
      bottom: 20px;
      width: 108px;
      height: 52px;
      object-fit: contain;
      filter: drop-shadow(0 6px 7px rgba(15, 23, 42, 0.22));
      animation: truckBob 1.25s ease-in-out infinite;
    }
    .tow-truck-shadow {
      position: absolute;
      left: 74px;
      bottom: 14px;
      width: 84px;
      height: 10px;
      border-radius: 999px;
      background: rgba(15, 23, 42, 0.2);
      filter: blur(1px);
      animation: shadowPulse 1.25s ease-in-out infinite;
    }
    .tow-truck-loader p {
      margin: 0;
      font-size: 0.9rem;
      font-weight: 600;
    }
    @keyframes truckBob {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-2px); }
    }
    @keyframes shadowPulse {
      0%, 100% { transform: scaleX(1); opacity: 0.22; }
      50% { transform: scaleX(0.9); opacity: 0.14; }
    }
    @keyframes roadShift {
      0% { background-position: 0 0; }
      100% { background-position: -140% 0; }
    }
  `;

  document.head.appendChild(style);
}

export function showReportLoading() {
  injectStyles();
  Swal.fire({
    title: 'Procesando reporte...',
    html: `
      <div class="tow-truck-loader" role="status" aria-live="polite">
        <div class="tow-truck-scene" aria-hidden="true">
          <img class="tow-truck" src="${truckMarker}" alt="" />
          <div class="tow-truck-shadow"></div>
          <div class="tow-truck-road"></div>
        </div>
        <p>Por favor, espera un momento...</p>
      </div>
    `,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    customClass: {
      popup: POPUP_CLASS,
    },
  });
}

export function hideReportLoading() {
  Swal.close();
}
